import "../../App.css";
import React, { Component, createRef } from "react";
import Nav from "react-bootstrap/Nav";
import Card from "react-bootstrap/Card";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { inject, observer } from "mobx-react";
import TextureList from "./TextureList";
import $ from "jquery";
import { BASE_URL, TOKEN, PRODUCT_CATEGORIES_ENDPOINT, CATEGORY_PRODUCT_ENDPOINT } from "../../Constants";
import axios from "axios";

@inject("store")
@observer
class FloorTextureModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      categoryId: null,
      categoryName: null,
      products: [],
      currentPage: 1,
      key: "",
      textures: [],
      loading: false,
      highlightedIndex: 0,
    };
    this.navRef = createRef();
  }

  async componentDidMount() {
    const currentPath = window.location.pathname;
    const hasViewKey = currentPath.includes("/view/");
    if(hasViewKey) {
      this.props.store.setHasViewKey(true);
    }
    if (!this.props.store.getHasViewKey) {
      this.setState({ loading: true });
      await this.fetchCatagories(this.state.currentPage);
    }
  }

  async categoryProducts(k) {
    $("#loader").css("display", "flex");
    const clickedIndex = k - 1;
    const elements = document.querySelectorAll(".texture-select-thumbnail");
    elements.forEach((element) => {
      element.classList.remove("texture-active");
    });

    if (this.state.highlightedIndex === clickedIndex) {
      // Clicked on the already highlighted item, remove the highlight
      this.setState({ highlightedIndex: -1 });
    } else {
      // Clicked on a different item, highlight it
      this.setState({ highlightedIndex: clickedIndex });
    }
    let selectedCategory = this.state.categories[k - 1];
    await this.fetchProducts(selectedCategory.id);
      this.setState({
        catalogId: selectedCategory.categoryId,
        categoryName: selectedCategory.name,
      });
      await this.scrollToHighlightedIndex();
  }

  async fetchCatagories(page, allCategories = []) {
    await axios
      .get(BASE_URL + PRODUCT_CATEGORIES_ENDPOINT, {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
        params: {
          page: page,
        },
      })
      .then((response) => {
        const newData = response.data.data;
        const categories = allCategories.concat(newData);

        if (page < response.data.last_page) {
          // If there are more pages, recursively fetch the next page
          return this.fetchCatagories(page + 1, categories);
        } else {
          // Filter out categories with names containing "-floor/wall", "- wall", or "- floor"
          const filteredCategories = categories.filter(category => 
            category.name.includes('- floor/wall') ||
            category.name.includes('- floor')
          );

          const floor = [];

          filteredCategories.forEach((category) => {
            const name = category.name || "";
            const lowerCaseName = name.toLowerCase();

            if (lowerCaseName.includes("-")) {
              if (lowerCaseName.includes("floor/wall")) {
                floor.push(category);
              } else if (lowerCaseName.includes("floor")) {
                floor.push(category);
              }
            }
        });
        // Find the index of the category with name "Tile"
        const tileFloorIndex = floor.findIndex(category => category.name.toLowerCase() === "tile - floor");
        // If "door frame" category is found, remove it from its current position and place it at the beginning
        if (tileFloorIndex !== -1) {
          const tileFloorCategory = floor.splice(tileFloorIndex, 1)[0];
          floor.unshift(tileFloorCategory);
        }

          this.fetchProducts(floor[0].id);

          this.setState({
            categories: floor,
            key: floor[0].id,
            catalogId: floor[0].id,
            categoryName: floor[0].name,
            loading: false
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
      });
  }

  async fetchProducts (id, page=1, allProducts = []) {
    await axios
      .get(BASE_URL + CATEGORY_PRODUCT_ENDPOINT, {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
        params: {
          category_id: id,
          page: page,
        },
      }).then((response) => {
        const data = response.data.data;
        const updateProducts = allProducts.concat(data);

        if (page < response.data.last_page) {
          // If there are more pages, recursively fetch the next page
          return this.fetchProducts(id, page + 1, updateProducts);
        } else {
          this.setState({
            products: updateProducts.reverse(),
            loading: false
          });
        }
        $("#loader").css("display", "none");
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
        $("#loader").css("display", "none");
      });
  }

  handleNextCatalog = () => {
    if (this.state.highlightedIndex < this.state.categories.length - 1) {
      this.setState(
        (prevState) => ({
          highlightedIndex: prevState.highlightedIndex + 1,
        }),
      );
      this.scrollToHighlightedIndex();
    }
  };

  handlePrevCatalog = () => {
    if (this.state.highlightedIndex > 0) {
      this.setState(
        (prevState) => ({
          highlightedIndex: prevState.highlightedIndex - 1,
        }),
      );
      this.scrollToHighlightedIndex();
    }
  };

  scrollToHighlightedIndex = () => {
    const navItem = this.navRef.current.children[this.state.highlightedIndex];
    if (navItem) {
      navItem.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  };

  // handelClick = (data) => {
  //   const { store } = this.props;
  //   this.props.setSelectedCardData(data);

  //   store.setClickListener(true);
  // };

  render() {
    const { store } = this.props;
    const { products, categoryId, categories, loading, categoryName } = this.state;
    if (categoryName) {
      if (categoryName.toLowerCase() !== "tile - floor" || categoryName.toLowerCase() !== "ceramic - floor/wall") {
        $("#texture-grouting-context-menu").hide();
      }
    }
    return (
      <Card className="texture-card">
        <Card.Header className="p-0">
          <div className="catagory-container">
            <button
              className="arrow-btn"
              onClick={this.handlePrevCatalog}
              disabled={this.state.highlightedIndex === 0}
            >
              <FaAngleLeft />
            </button>
            <Nav
              ref={this.navRef}
              className="catagory-wrapper"
              variant="underline"
              defaultActiveKey={this.state.highlightedIndex + 1}
              onSelect={(k) => {
                this.categoryProducts(k);
              }}
            >
              {categories.map((category, index) => (
                <Nav.Item key={category.id}>
                  <Nav.Link
                    eventKey={index + 1}
                    className={
                      index === this.state.highlightedIndex ? "highlighted" : ""
                    }
                  >
                    {category.name.split("-")[0].trim()}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
            <button
              className="arrow-btn"
              onClick={this.handleNextCatalog}
              disabled={
                this.state.highlightedIndex === this.state.textures.length - 1
              }
            >
              <FaAngleRight />
            </button>
          </div>
        </Card.Header>
        <Card.Body className="p-0">
        {products &&(
          <TextureList
            category_id={categoryId}
            products={products}
            categoryName={categoryName}
            loggedIn={store.getLoggedIn}
            // setSelectedCardData={this.handelClick}
          />
        )}
        </Card.Body>
      </Card>
    );
  }
}

export default FloorTextureModal;
